import $ from '@nuskin/nuskinjquery';
import {util} from '@nuskin/ns-util';
import {UserService}  from '@nuskin/ns-account';
import CartService    from '../cart/cartService.js';
import ProductService from '../cart/productService.js';

let CartToShopCartAdaptor = function (oldCart/*, callback*/) {
    let qtyTable = new $.Hashtable();
    let maxQtyTable = new $.Hashtable();

    let userId = UserService.getUser().id;
    let cntryCd = util.getSiteConfig().markets;
    let language = 'en';
    let adr = false;
    let isBusinessPortfolio = false;

    // Add all the product into the new cart
    let cartItems = oldCart.getItems();
    let sku;
    for (let i = 0; i < cartItems.length; i++) {
        if (cartItems[i].getQty() > 0) {
            sku = cartItems[i].sku;
            qtyTable.add(sku, cartItems[i].getQty());
            maxQtyTable.add(sku, cartItems[i].getMaxQty());

            let productOptions = {};
            productOptions.sku = sku;
            productOptions.cntryCd = cntryCd;
            productOptions.language = language;

            ProductService.getProductBySku(productOptions)
                .then(result => {
                    if (result.success === true) {
                        let options = {};

                        options.product = result.product;
                        options.userId = userId;
                        options.cntryCd = cntryCd;
                        options.adr = adr;
                        options.isBusinessPortfolio = isBusinessPortfolio;

                        options.sku = result.product.sku;
                        options.qty = qtyTable.get(options.sku);
                        options.maxQty = maxQtyTable.get(options.sku);

                        CartService.addProductToCart(options).finally(() => {});
                    }
                });
        }
    }
};

export default CartToShopCartAdaptor;
